<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link to="/dashboard">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page"><i class="fas fa-search"></i> Search</li>
            </ol>
        </nav>

        <h4 class="page-header">
            <i class="fas fa-search"></i> Search All Records: {{ searchTerm }}
        </h4>

        <div class="alert alert-warning" v-if="!saving && (searchTerm || '').trim().length < 2">Enter at least 2 characters to search.</div>
        <div class="alert alert-info" v-if="limited.length">Some results were cut off at {{ maxResults }}. Try a more specific search.</div>

        <div class="card mb-4">
            <div class="card-header">Agents ({{ agents.length }}<span v-if="limited.includes('agents')">+, showing the first {{ maxResults }}</span>)</div>
            <div class="card-body">
                <v-client-table :columns="['id', 'first_name', 'last_name', 'npn', 'tax_id']" :options="{filterable: false, headings: {product_name: 'Product', product_type_name: 'Product Type'}}" :data="agents">

                    <template slot="id" slot-scope="props">
                        <router-link :to="`/agents/view/${props.row.id}`" title="View Agent">View Agent</router-link>
                    </template>

                </v-client-table>
            </div>
        </div>

        <div class="card mb-4">
            <div class="card-header">Agencies ({{ agencies.length }}<span v-if="limited.includes('agencies')">+, showing the first {{ maxResults }}</span>)</div>
            <div class="card-body">
                <v-client-table :columns="['id', 'agency_name']" :options="{filterable: false, headings: {product_name: 'Product', product_type_name: 'Product Type'}}" :data="agencies">

                    <template slot="id" slot-scope="props">
                        <router-link :to="`/agencies/view/${props.row.id}`" title="View Agency">View Agency</router-link>
                    </template>

                </v-client-table>
            </div>
        </div>

        <div class="card mb-4">
            <div class="card-header">Contracts ({{ contracts.length }}<span v-if="limited.includes('contracts')">+, showing the first {{ maxResults }}</span>)</div>
            <div class="card-body">
                <v-client-table :columns="['id', 'writing_nbr', 'product_name', 'seller_name']" :options="{filterable: false, headings: {writing_nbr: 'Writing#', product_name: 'Product', seller_name: 'Agent/Agency'}}" :data="contracts">

                    <template slot="id" slot-scope="props">
                        <router-link :to="`/contracts/view/${props.row.id}`" title="View Contract">View Contract</router-link>
                    </template>

                </v-client-table>
            </div>
        </div>

        <div class="card mb-4">
            <div class="card-header">Clients ({{ clients.length }}<span v-if="limited.includes('clients')">+, showing the first {{ maxResults }}</span>)</div>
            <div class="card-body">
                <v-client-table :columns="['id', 'client_name']" :options="{filterable: false, headings: {product_name: 'Product'}}" :data="clients">

                    <template slot="id" slot-scope="props">
                        <router-link :to="`/clients/view/${props.row.id}`" title="View Client">View Client</router-link>
                    </template>

                </v-client-table>
            </div>
        </div>

        <div class="card">
            <div class="card-header">Policies ({{ policies.length }}<span v-if="limited.includes('policies')">+, showing the first {{ maxResults }}</span>)</div>
            <div class="card-body">
                <v-client-table :columns="['id', 'policy_number', 'product_name', 'client_name', 'agent_name']" :options="{filterable: false, headings: {product_name: 'Product', policy_number: 'Policy#'}}" :data="policies">

                    <template slot="id" slot-scope="props">
                        <router-link :to="`/policies/view/${props.row.id}`" title="View Policy">View Policy</router-link>
                    </template>

                </v-client-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                user: this.$store.state.user,
                errors: {},
                searchTerm: this.$route.query.q,

                //Search Entities
                agents: [],
                agencies: [],
                contracts: [],
                clients: [],
                policies: [],
                maxResults: 0,
                limited: [],
            }
        },

        computed: {

        },

        methods: {

            getSearchResults(){
                //Helpers
                this.saving = true;
                this.errors = {};

                //Send it
                this.$http
                .get('/search', this.$route.query)
                .then(response => {
                    //Set All
                    this.agents = response.data.agents;
                    this.agencies = response.data.agencies;
                    this.contracts = response.data.contracts;
                    this.clients = response.data.clients;
                    this.policies = response.data.policies;
                    this.maxResults = response.data.max_results;
                    this.limited = response.data.limited || [];

                    //Return to main list?
                    //this.$router.push('/');
                })
                .catch(error => {
                    //Check for error
                    if(error.response && error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Find Search Results');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }

        },

        mounted() {
            //Get it
            this.getSearchResults();
        }
    }
</script>
